/**
 * VEYR homepage entry — black threshold.
 * Accessible dialog, focus trap, once per session. Silence default. No audio UI.
 */
(function () {
  if (window.__veyrEntryInit) return;
  window.__veyrEntryInit = true;

  const STORAGE_KEY = 'veyr-entry-seen';
  const FOCUSABLE =
    'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const entry = document.getElementById('veyr-entry');
  const isDesignMode = window.Shopify && window.Shopify.designMode;

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
      return true;
    } catch {
      return false;
    }
  }

  function getFocusableNodes(container) {
    return Array.from(container.querySelectorAll(FOCUSABLE)).filter(function (node) {
      return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)
        || node === document.activeElement;
    });
  }

  if (!entry) return;

  let dismissed = false;
  let previousFocus = null;
  const enterBtn = entry.querySelector('.veyr-entry__enter');
  const skipBtn = entry.querySelector('.veyr-entry__skip');

  function finishEntry() {
    document.documentElement.classList.remove('veyr-entry-active');
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
  }

  function dismiss() {
    if (dismissed) return;
    dismissed = true;
    storageSet(STORAGE_KEY, '1');
    entry.classList.add('is-dismissed');
    entry.removeEventListener('keydown', onKeydown);

    entry.addEventListener(
      'transitionend',
      function () {
        entry.remove();
        finishEntry();
      },
      { once: true }
    );

    setTimeout(function () {
      if (entry.parentNode) {
        entry.remove();
        finishEntry();
      }
    }, 900);
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      dismiss();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusableNodes(entry);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openEntry() {
    previousFocus = document.activeElement;
    document.documentElement.classList.add('veyr-entry-active');
    entry.hidden = false;
    entry.addEventListener('keydown', onKeydown);
    requestAnimationFrame(function () {
      entry.classList.add('is-ready');
      (enterBtn || skipBtn)?.focus();
    });
  }

  if (isDesignMode || storageGet(STORAGE_KEY) === '1') {
    entry.remove();
    return;
  }

  enterBtn?.addEventListener('click', dismiss);
  skipBtn?.addEventListener('click', dismiss);

  openEntry();
})();
